import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Customer_Report_Filter from "./customer_report_filter/Customer_Report_Filter";
import Customer_Report_Table from "./customer_report_table/Customer_Report_Table";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCustomerReport,
  GetInstrumantReport,
} from "../../../../../features/admin/report_generator/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";

const Customer_Report = () => {
  const [show, setShow] = useState(false);
  const [searchParams, setSearchParams] = useState({
    unique_id: "",
    email: "",
    organization_name: "",
    contact_person_name: "",
    customer_status_id: "",
    end_date: "",
    start_date: "",
    year: ""
  });

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(FixIDS.customer_report.Report);

  const dispatch = useDispatch();
  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetCustomerReport({
        unique_id: searchParams.unique_id || "",
        email: searchParams.email || "",
        organization_name: searchParams.organization_name || "",
        contact_person_name: searchParams.contact_person_name || "",
        customer_status_id: searchParams.customer_status_id || "",
        start_date: searchParams.start_date || "",
        end_date: searchParams.end_date || "",
        page: 1,
        per_page: 10,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
       const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);     
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Customer Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Customer_Report_Filter
          setShow={setShow}
          setSearchName={setSearchParams}
          reportgenerate={reportgenerate}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Customer_Report_Table searchName={searchParams} />}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Customer Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Customer_Report;
